export const environment = {
  name: 'prod',
  production: true,
  settings: {
    apiBaseUrl: 'http://localhost:3000',
    websocketBaseUrl: 'ws://localhost:3000/ws-api',
    analyticsKey: 'UA-121554636-3',
  },
};
